import { render } from "./ThePointsbar.vue?vue&type=template&id=6b0c4947&scoped=true"
import script from "./ThePointsbar.vue?vue&type=script&lang=js"
export * from "./ThePointsbar.vue?vue&type=script&lang=js"

import "./ThePointsbar.vue?vue&type=style&index=0&id=6b0c4947&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\haqua\\Documents\\vue\\rebrand\\feedback-page-resell\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0c4947"]])

export default __exports__